module.exports = __webpack_public_path__ + "img/img2.c2269687.png";